import { getInputById } from './getInputById'
import { showSelectError } from '../html/showSelectError'

/**
 * Checks if required inputs are empty
 * @param {FunnelMainSubmitData} detail - The form fields
 * @param {FormSubmitSelectArray} selects - The input ids
 * @returns {string[]} - The form error state
 */
export function checkSubmitSelects(detail, selects) {
  const invalidSelects = selects.reduce(
    (validAccumulator, field) => {
      const select = getInputById(field)

      if (!select || !detail[field]) {
        if (select && select instanceof HTMLSelectElement) {
          showSelectError(select)
        }
        validAccumulator.push(field)
      }

      return validAccumulator.filter((i) => i !== '')
    },
    [''],
  )
  return invalidSelects.filter((i) => i !== '')
}
